import { api } from '../api';

export const preAuthorizationService = {
  async fetchPreAuthorizations(params) {
    return api.get('pre-authorizations', { params });
  },

  async fetchPreAuthorization(id) {
    return api.get('pre-authorizations/' + id );
  },

  async createPreAuthorization(params) {
    return api.post('pre-authorizations', params);
  },
}; 